import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';
import { Modal } from 'react-bootstrap';

import { blackberry } from 'lib/css/colors';

function BrandCleanupModal({ brandCleanupRecord, onHide }) {
  const reasonings = brandCleanupRecord?.reasonings || {};

  const reasoningFields = [
    {
      key: 'brand_category_verification_reason',
      label: 'Brand Category Verification',
    },
    {
      key: 'brand_retry_verification_reason',
      label: 'Brand Retry Verification',
    },
    {
      key: 'manufacturer_brand_verification_reason',
      label: 'Manufacturer Brand Verification',
    },
    {
      key: 'manufacturer_category_verification_reason',
      label: 'Manufacturer Category Verification',
    },
  ];

  return (
    <Modal show={true} onHide={onHide} size="xl" className="lato" centered>
      <Modal.Header closeButton>
        <Modal.Title className={classNames(css(styles.heading))}>
          Brand Cleanup Reasonings
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={css(styles.reasoningsContainer)}>
          {reasoningFields.map(({ key, label }) => (
            <div key={key} className={css(styles.reasoningSection)}>
              <div className={css(styles.reasoningLabel)}>{label}</div>
              <div className={css(styles.reasoningContent)}>
                {reasonings[key] || (
                  <span className={css(styles.emptyText)}>No reason provided</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-start"></Modal.Footer>
    </Modal>
  );
}

const styles = StyleSheet.create({
  heading: {
    fontWeight: 'bold',
    fontFamily: 'Mont, sans-serif',
    fontSize: '1.5rem',
  },
  reasoningsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
  reasoningSection: {
    borderBottom: '1px solid #e0e0e0',
    paddingBottom: '1rem',
    ':last-child': {
      borderBottom: 'none',
      paddingBottom: 0,
    },
  },
  reasoningLabel: {
    fontWeight: 'bold',
    fontSize: '1rem',
    marginBottom: '0.5rem',
    color: blackberry,
    fontFamily: 'Mont, sans-serif',
  },
  reasoningContent: {
    fontSize: '0.95rem',
    lineHeight: '1.6',
    color: '#333',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  emptyText: {
    fontStyle: 'italic',
    color: '#999',
  },
});

BrandCleanupModal.propTypes = {
  brandCleanupRecord: PropTypes.object,
  onHide: PropTypes.func,
};

export default BrandCleanupModal;
